import api from "./axios";
import { SendUsageHistoryParams } from "@/struct/HistoryStruct";

export default class HistoryService {
  getPurchaseHistory = (
    limit: number,
    start: number,
    start_time: string,
    end_time: string
  ) => {
    return api.get("/api/web-api/get-purchase-history", {
      params: { limit, start, start_time, end_time },
    });
  };

  getUsageHistory = (limit: number, start_time: string, end_time: string) => {
    return api.get("/api/web-api/get-usage-history", {
      params: { limit, start_time, end_time },
    });
  };

  sendUsageHistory = (params: SendUsageHistoryParams) => {
    return api.get("/api/web-api/send-usage-history", {
      params: {
        type: params.type.toLowerCase(),
        email: params.email,
        start_time: params.start_time,
        end_time: params.end_time,
      },
    });
  };
}
